import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const features = [
  { icon: 'ri-shield-check-line', text: 'Resmi ManageEngine Partner — Türkiye', color: '#0891B2' },
  { icon: 'ri-robot-2-line', text: 'AutomMate low-code/no-code otomasyon uzmanlığı', color: '#F97316' },
  { icon: 'ri-apps-line', text: 'Zoho ONE uygulama kurulumu ve danışmanlık', color: '#0891B2' },
  { icon: 'ri-award-line', text: '12+ yıllık kurumsal IT deneyimi', color: '#F97316' },
  { icon: 'ri-customer-service-line', text: 'Eğitim, kurulum, destek ve bakım hizmetleri', color: '#0891B2' },
  { icon: 'ri-bar-chart-box-line', text: '400+ başarıyla tamamlanmış proje', color: '#F97316' },
];

const About = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from('.ab-left', { scrollTrigger: { trigger: '.ab-left', start: 'top 80%' }, opacity: 0, x: -40, duration: 1, ease: 'power3.out' });
      gsap.from('.ab-right', { scrollTrigger: { trigger: '.ab-right', start: 'top 80%' }, opacity: 0, x: 40, duration: 1, ease: 'power3.out' });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} id="about" className="py-24 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left — image */}
          <div className="ab-left relative order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden border border-[#E2E8F0]">
              <img
                src="https://public.readdy.ai/ai/img_res/ff16ea26458c5875ebbe204d7fa25908.jpg"
                alt="WOTECH IT Danışmanlık Ekibi"
                title="WOTECH — Kurumsal IT Danışmanlık"
                className="w-full h-80 object-cover object-top"
              />
            </div>

            {/* Stat card overlay */}
            <div className="absolute -bottom-6 -right-4 bg-white rounded-2xl border border-[#E2E8F0] p-5 flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#ECFEFF] flex-shrink-0">
                <i className="ri-trophy-line text-[#0891B2] text-2xl"></i>
              </div>
              <div>
                <div className="text-2xl font-extrabold text-[#0F172A] font-heading">400+</div>
                <div className="text-sm text-[#64748B] font-body">Başarılı Kurumsal Proje</div>
              </div>
            </div>
          </div>

          {/* Right — content */}
          <div className="ab-right order-1 lg:order-2 lg:pl-6">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#ECFEFF] border border-[#0891B2]/30 text-[#0E7490] text-xs font-semibold mb-5 font-body">
              <i className="ri-information-line"></i>
              Hakkımızda
            </div>
            <h2 className="text-4xl font-extrabold text-[#0F172A] mb-5 font-heading leading-tight">
              WOTECH Kimdir?
            </h2>
            <p className="text-base text-[#475569] leading-relaxed mb-8 font-body">
              <strong className="text-[#0F172A]">WOTECH</strong>; ManageEngine, AutomMate ve Zoho ONE ürünlerinde uzmanlaşmış kurumsal bir IT danışmanlık firmasıdır. Uç nokta yönetimi, servis yönetimi, Active Directory, otomasyon, entegrasyon ve iş uygulamaları alanlarında <strong className="text-[#0891B2]">uçtan uca çözümler</strong> sunuyoruz.
            </p>

            <ul className="space-y-3">
              {features.map((f, i) => (
                <li key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: `${f.color}15` }}>
                    <i className={`${f.icon} text-base`} style={{ color: f.color }}></i>
                  </div>
                  <span className="text-sm font-medium text-[#334155] font-body">{f.text}</span>
                </li>
              ))}
            </ul>

            <a href="#contact" className="inline-flex items-center gap-2 mt-8 px-6 py-3.5 bg-[#0891B2] text-white font-semibold rounded-lg hover:bg-[#0E7490] transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer font-body">
              <i className="ri-phone-line"></i>
              Bizimle İletişime Geçin
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
